import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import helpers from '../../Utils/helpers'
import Modals from "../../Constants/modals";
import useModal from "../../Hooks/useModal";
import SkynetIcon from "../Fundamentals/SkynetIcon";
import CollaborationTerminationModal from "./Modals/CollaborationTerminationModal";
import { hasReadWriteAccess } from '../../Utils/permissionUtils';
import { UserRoles } from '../../Constants/userRoles';
import { useSelector } from 'react-redux';
import customerRoutes from "../../Constants/Customer/customerRoutes";

const CollaborationsList = ({ collaborations, handleSortChange, sortOrder, sortKey, listOfServiceNames, showConsultant, customerActions, refreshCollaborations }) => {
    const { t } = useTranslation();

    const filter = localStorage.getItem("CollaborationsFilter");
    const [filterOptions, setFilterOptions] = useState(false);
    const user = useSelector((state) => state.CommonReducer.user);

    const { openModal, isModalOpen } = useModal();

    const filterCollaborationsByProduct = (filterId) => {
        localStorage.setItem("CollaborationsFilter", filterId);

        filterChoices();
    }

    const filterChoices = () => {
        setFilterOptions(!filterOptions);
    }

    const navigateToCustomer = (customerNumber) => {
         window.open(customerRoutes.customer(customerNumber));
    }

    const productNames = () => {
        const filterList = [];
        listOfServiceNames.map(item => {
            filterList.push({
                id: item,
                name: item
            })
        })
        filterList.push({
            id: "all",
            name: t("all")
        }
        )
        return filterList;
    }

    const showTerminationModal = collaboration => {
        if (!hasReadWriteAccess(user, UserRoles.CollaborationManager)) {
            return;
        }

        customerActions.openCollaborationTermination(collaboration);
        openModal(Modals.CollaborationTermination);
    }

    const onDeleteTermination = collaborationId => {
        if (!hasReadWriteAccess(user, UserRoles.CollaborationManager)) {
            return;
        }

        customerActions.deleteCollaborationTermination(collaborationId, refreshCollaborations);
    }

    const filterIsUsed = () => filter && filter !== 'all';

    if (filterIsUsed())
        collaborations = collaborations.filter(c => c.product === filter);

    const sortIcon = sortOrder === "asc" ? "vismaicon vismaicon-sm vismaicon-arrow-up-circle" : "vismaicon vismaicon-sm vismaicon-arrow-down-circle";
    const productNamesList = productNames();

    const filterUsed = filterIsUsed() && <span className="badge badge-default">{'\u2714'}</span>

    const CollabTableHeader = ({ children, onClick }) => {
        return <th className="text-left">
            <div className="cursorpointer d-flex justify-content-between align-items-center" onClick={onClick}>
                {children}
            </div>
        </th>
    }

    return <div className="table-responsive mt-10">
        <table className="table table-stripe">
            <thead>
                <tr>
                    {showConsultant ? <>
                        <CollabTableHeader onClick={() => handleSortChange('consultantNumber')}>{t('collaboration.consultantnumber')} {sortKey === 'consultantNumber' && <i className={sortIcon}></i>} </CollabTableHeader>
                        <CollabTableHeader onClick={() => handleSortChange('consultantName')}>{t('collaboration.consultantname')} {sortKey === 'consultantName' && <i className={sortIcon}></i>} </CollabTableHeader>
                    </> : <>
                        <CollabTableHeader onClick={() => handleSortChange('organizationNumber')}>{t('common.organizationnumber')} {sortKey === 'organizationNumber' && <i className={sortIcon}></i>} </CollabTableHeader>
                        <CollabTableHeader onClick={() => handleSortChange('customerNumber')}>{t('collaboration.customernumber')} {sortKey === 'customerNumber' && <i className={sortIcon}></i>} </CollabTableHeader>
                        <CollabTableHeader onClick={() => handleSortChange('name')}>{t('collaboration.customername')} {sortKey === 'name' && <i className={sortIcon}></i>} </CollabTableHeader>
                    
                    </>}

                    <th className="text-left" >{t('collaboration.noninteractive')}</th>
                    <CollabTableHeader onClick={filterChoices}>
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <span>{t('collaboration.product')}</span>
                            <span className="d-flex align-items-center ms-auto">
                                {filterUsed}
                                <i className="vismaicon vismaicon-sm vismaicon-filter ms-2" title={t('internalleadslist.filter')}></i>
                            </span>
                        </div>
                        {filterOptions && (
                            <div className="table-dropdown">
                                {productNamesList.map((choice, index) => (
                                    <span key={index} onClick={() => filterCollaborationsByProduct(choice.id)}>
                                        {choice.name}<br />
                                    </span>
                                ))}
                            </div>
                        )}
                    </CollabTableHeader>
                    <CollabTableHeader onClick={() => handleSortChange('moduleName')}>{t('collaboration.module')} {sortKey === 'moduleName' && <i className={sortIcon}></i>} </CollabTableHeader>
                    <CollabTableHeader onClick={() => handleSortChange('period')}>{t('collaboration.period')} {sortKey === 'period' && <i className={sortIcon}></i>} </CollabTableHeader>
                    <CollabTableHeader onClick={() => handleSortChange('invoiceParty')}>{t('collaboration.invoicereceiver')} {sortKey === 'invoiceParty' && <i className={sortIcon}></i>} </CollabTableHeader>
                    <CollabTableHeader onClick={() => handleSortChange('created')}>{t('created')} {sortKey === 'created' && <i className={sortIcon}></i>} </CollabTableHeader>
                    <CollabTableHeader onClick={() => handleSortChange('collaborationEndDate')}>{t('collaboration.collaborationEndDate')} {sortKey === 'collaborationEndDate' && <i className={sortIcon}></i>} </CollabTableHeader>
                    
                    {hasReadWriteAccess(user, UserRoles.CollaborationManager) &&
                        <th width="50" className="text-left">{t('vonproducts.termination')}</th>
                    }
                </tr>
            </thead>
            <tbody>
                {collaborations.map((collaboration, index) => {
                    return <tr key={index}>
                        {showConsultant ? <>
                            <td><a onClick={() => navigateToCustomer(collaboration.consultantNumber)}>{collaboration.consultantNumber}</a></td>
                            <td>{collaboration.consultantName} </td>
                        </> : <>
                            <td>{collaboration.customerNumber ? <a onClick={() => navigateToCustomer(collaboration.customerNumber)}>{collaboration.organizationNumber}</a> : collaboration.organizationNumber}</td>
                            <td><a onClick={() => navigateToCustomer(collaboration.customerNumber)}>{collaboration.customerNumber}</a></td>
                            <td>{collaboration.name}</td>
                        </>
                        }

                        <td>{collaboration.isNonInteractive ? t('common.yes') : t('common.no')}</td>
                        <td>{collaboration.product}</td>
                        <td>{collaboration.moduleName ? collaboration.moduleName : "n/a"}</td>
                        <td>{collaboration.period}</td>
                        <td>{collaboration.invoiceParty}</td>
                        <td>{helpers.formatDate(collaboration.created)}</td>
                        <td>{collaboration.collaborationEndDate ? helpers.formatDate(collaboration.collaborationEndDate) : ''}</td>

                        {hasReadWriteAccess(user, UserRoles.CollaborationManager) &&
                            <td>
                                {
                                    collaboration.isTerminationPending ?
                                        <>{t('collaboration.terminationscheduled')} - <a onClick={() => onDeleteTermination(collaboration.id)}>{t('collaboration.canceltermination')}</a></>
                                        :
                                        <SkynetIcon icon={"vismaicon-delete vismaicon-sm ml-8"}
                                            onClick={() => { showTerminationModal(collaboration); }} />
                                }
                            </td>
                        }
                    </tr>
                })}
            </tbody>
        </table>

        {isModalOpen(Modals.CollaborationTermination) && <CollaborationTerminationModal onSubmit={() => {
            refreshCollaborations();
        }} />}

    </div>
}

export default CollaborationsList;